import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootReducer from '../reducers';
import getSagas from '../sagas';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredPaths: ['avatars'],
      },
    }).concat(sagaMiddleware),

  devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(getSagas);

export type AppDispatch = typeof store.dispatch;

export default store;
